import TenantConfig from './TenantConfig';

export default TenantConfig;
